const concatClasses = (...classes:string[]) => {
  return classes.join(" ");
};

export default concatClasses